import ProviderProfile from '@/apps/provider/profile/ProviderProfile.vue';

const profileRoutes = [
  {
    path: '/provider/profile/:care_type/:sitter_uuid',
    name: 'provider-profile',
    component: ProviderProfile,
  },
];

export default profileRoutes;
